import { useExamDistributionByMonth } from '@exam-center/exam-distribution';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { CalendarTodayOutlinedIcon, Loading, NoRowsOverlay } from '@shared/components';
import { useHasPermission } from '@shared/permissions';
import { useMemo } from 'react';

import { BaseMonthlyExamDistributionTable } from '../../components';

import {
  mapExamCourseHeaders,
  mapExamDistributionData,
  getUniqueExamCoursesFromExamEventCourses,
} from './mapper';

export default function MonthlyExamDistributionTable() {
  const { examDistributionData, isExamDistributionDataEmpty, isLoading } =
    useExamDistributionByMonth();

  const canUpdate = useHasPermission(APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.EXAM_ASSIGNING.UPDATE);

  const { examEvents, examEventCourses, examCourses } = examDistributionData;

  const examCoursesInEvents = useMemo(
    () =>
      !isLoading ? getUniqueExamCoursesFromExamEventCourses(examCourses, examEventCourses) : [],
    [examCourses, examEventCourses, isLoading],
  );

  const examCourseHeaders = useMemo(() => {
    return !isLoading ? mapExamCourseHeaders(examCoursesInEvents) : [];
  }, [examCoursesInEvents, isLoading]);

  const examDistributionRows = useMemo(() => {
    return !isLoading
      ? mapExamDistributionData(examEvents, examCourses, examEventCourses, canUpdate)
      : [];
  }, [examEvents, examEventCourses, examCourses, isLoading, canUpdate]);

  if (isLoading) {
    return <Loading />;
  }

  if (!examDistributionRows.length && isExamDistributionDataEmpty) {
    return (
      <NoRowsOverlay
        title='ยังไม่มีรอบสอบในเดือนนี้'
        description='ระบบจะแสดงรอบสอบหลังจากศูนย์สอบเพิ่มข้อมูลแล้ว'
        icon={CalendarTodayOutlinedIcon}
      />
    );
  }

  return (
    <BaseMonthlyExamDistributionTable data={examDistributionRows} courses={examCourseHeaders} />
  );
}
